import * as angular from "angular";
import {IController} from "angular";

export class BringozRouteTypeSelectComponent implements IController {
  routeType: any;
  isDisabled: any;
  ngRequired: any;
  ngPlaceholder: any;
  noUnderline: any;
  onChange: Function;

  selectOptions: any;

  constructor(private commonsConstants, private $mdSelect) {
  }

  $onInit() {
    this.selectOptions = this.commonsConstants.routeTypes;
  }


  reset() {
    this.onChange({routeType: undefined});
    this.$mdSelect.hide();
  }

  cancel() {
    this.$mdSelect.hide();
  }

  select() {
    this.onChange({routeType: this.routeType});
    this.$mdSelect.hide();
  }
}


angular
  .module('bringoz.admin.commons')
  .component('bringozRouteTypeSelect', {
    bindings: {
      routeType: '<',
      isDisabled: '<?',
      ngRequired: '@?',
      ngPlaceholder: '@?',
      noUnderline: '@?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-route-type-select/bringoz-route-type-select.html',
    controller: BringozRouteTypeSelectComponent
  });
